import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import '../Home.css'

export default function Cards() {
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.2 }
        );
    
        const cardsDiv = document.querySelector('#cards-div');
        if (cardsDiv) {
          observer.observe(cardsDiv);
        }
    
        return () => {
          if (cardsDiv) {
            observer.unobserve(cardsDiv);
          }
        };
    }, []);

    return (
        <div id="cards-div" className={`flex flex-wrap justify-center gap-36 mt-20 transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-0'}`}>
            <div onClick={() => navigate('/WindFree')} className="w-full md:w-3/3 lg:w-1/3 overflow-hidden shadow-lg rounded-2xl transition-all duration-700 transform hover:scale-105 cursor-pointer">
                <div id="card1" ></div>
                <div className="px-6 py-4">
                <div className="font-bold text-xl mb-2">WindFree™ Cooling</div>
                <p className="text-gray-700 text-base">
                  Останете ладни без да чувствувате студ со користење на WindFree™ Cooling.
                </p>
                </div>
                <div className="px-6 pt-4 pb-2">
                <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                    <a href="/WindFree">Откриј повеќе</a>
                </span>
                </div>
            </div>
            <div onClick={() => navigate('/360Cassette')} className="w-full md:w-3/3 lg:w-1/3 overflow-hidden shadow-lg rounded-2xl transition-all duration-700 transform hover:scale-105 cursor-pointer">
                <div id="card2" ></div>
                <div className="px-6 py-4">
                <div className="font-bold text-xl mb-2">Опкружувачко ладење</div>
                <p className="text-gray-700 text-base">
                  360 Касетата на Samsung нуди стилско решение кое рамномерно го распределува воздухот во секој агол од собата.
                </p>
                </div>
                <div className="px-6 pt-4 pb-2">
                <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                    <a href="/360Cassette">Откриј повеќе</a>
                </span>
                </div>
            </div>
        </div>
    )
}